import { Button, Modal, Form, Col, Row } from 'react-bootstrap'
import UserService from '../../service/userService'
import UtilService from '../../service/utilService'
import { successNotify, errorNotify } from '../Utils/Toast'
import useToken from '../../App/useToken'
import React, { useState, useEffect } from 'react'

import './UserEditModal.css'

export default function UserEditModal({
  user,
  showUserEditModal,
  setShowUserEditModal,
  getRoleName,
  getUser,
  majorCourseBasic,
  majorCourseFinal,
}) {
  const { getToken, isAdmin } = useToken()
  const token = getToken()
  const isUserAdmin = isAdmin()
  const [role, setRole] = useState()
  const [ranks, setRanks] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false)
  const [rankAbbrName, setRankAbbrName] = useState(user?.rankAbbrName)
  const [fullName, setFullName] = useState(user?.fullName)
  const [password, setPassword] = useState()
  const [rtafEmail, setRtafEmail] = useState(user?.rtafEmail)
  const [isCourseUpdateShow, setIsCourseUpdateShow] = useState(false)
  const [courseUpdateAvailable, setCourseUpdateAvailable] = useState([
    '11',
    '12',
    '15',
  ])

  useEffect(async () => {
    if (user) {
      setRankAbbrName(user?.rankAbbrName)
      setFullName(user?.fullName)
      setRtafEmail(user?.rtafEmail)
      setPassword()
      setRole(user?.role)
      setCourseUpdateAvailable(user?.courseUpdateAvailable)
    }
  }, [user])

  useEffect(async () => {
    setIsCourseUpdateShow(true)
    // if (role === 'admin') {
    //   setIsCourseUpdateShow(true)
    // } else {
    //   setIsCourseUpdateShow(false)
    // }
  }, [role])

  useEffect(async () => {
    setIsLoadingData(true)
    const utilService = new UtilService()
    const rankRes = await utilService.getRank(token)
    if (rankRes?.length >= 0) setRanks(rankRes)
    setIsLoadingData(false)
  }, [])

  const handleClose = () => {
    setShowUserEditModal(false)
  }

  const handleDeleteUser = async () => {
    const userService = new UserService()
    const res = await userService.deleteUser(token, user?._id)
    if (res.type != 'error') {
      successNotify('ลบข้อมูลสำเร็จ')
      getUser()
    } else {
      errorNotify(res?.message?.message || 'เกิดข้อผิดพลาด')
    }
    setShowUserEditModal(false)
  }

  const handleOnUserSave = async (e) => {
    e.preventDefault()
    const userService = new UserService()
    const res = await userService.updateUser(token, user?._id, {
      rankAbbrName,
      fullName,
      password,
      rtafEmail,
      role,
      courseUpdateAvailable,
    })
    if (res.type != 'error') {
      successNotify('แก้ไขข้อมูลสำเร็จ')
      getUser()
    } else {
      errorNotify(res?.message?.message || 'เกิดข้อผิดพลาด')
    }
    setShowUserEditModal(false)
  }

  const onCourseUpdateAvailableChange = ({ target: { value, checked } }) => {
    if (checked) {
      setCourseUpdateAvailable([...courseUpdateAvailable, value])
    } else {
      const newArr = courseUpdateAvailable.filter((f) => f !== value)
      setCourseUpdateAvailable(newArr)
    }
  }

  const isCourseUpdateAvailableChecked = (value) => {
    return courseUpdateAvailable.includes(value)
  }

  useEffect(async () => {
    console.log('courseUpdateAvailable', courseUpdateAvailable)
  }, [courseUpdateAvailable])

  return (
    <>
      <Modal
        show={showUserEditModal}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'>
        {!isLoadingData && user && (
          <Form onSubmit={handleOnUserSave}>
            <Modal.Header closeButton>
              <Modal.Title>แก้ไข</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col md={2}>
                  <Form.Group as={Col}>
                    <Form.Label>ยศ :</Form.Label>
                    <Form.Control
                      as='select'
                      defaultValue={rankAbbrName}
                      onChange={(e) => {
                        setRankAbbrName(e.target.value)
                      }}>
                      {ranks.map((rank) => (
                        <option
                          selected={rank.name == rankAbbrName}
                          value={rank.name}>
                          {rank.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setFullName(e.target.value)}>
                    <Form.Label>ชื่อ - นามสกุล :</Form.Label>
                    <Form.Control defaultValue={`${user?.fullName}`} />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group as={Col}>
                    <Form.Label>ชื่อผู้ใช้ :</Form.Label>
                    <Form.Control value={user?.email || '-'} disabled />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group as={Col}>
                    <Form.Label>รหัสผ่าน :</Form.Label>
                    <Form.Control
                      onChange={(e) => {
                        setPassword(e.target.value)
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>อีเมล(RTAF) :</Form.Label>
                    <Form.Control
                      defaultValue={user?.rtafEmail || '-'}
                      onChange={(e) => {
                        setRtafEmail(e.target.value)
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>หน่วย :</Form.Label>
                    <Form.Control value={user?.unit || '-'} disabled />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>สายวิทยาการ :</Form.Label>
                    <Form.Control value={user?.unitSpcName || '-'} disabled />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>บทบาท :</Form.Label>
                    <Form.Control
                      as='select'
                      value={role}
                      disabled={!isUserAdmin}
                      onChange={(e) => {
                        setRole(e.target.value)
                      }}>
                      <option value='admin'>กพ.ทอ.</option>
                      <option value='adminViewer'>กพ.ทอ.(ReadOnly)</option>
                      <option value='adminUnitSpc'>
                        หน่วย หน. สายวิทยาการ
                      </option>
                      <option value='adminUnit'>นขต.ทอ.</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              {isCourseUpdateShow && (
                <Row className='course-update'>
                  <Col md={6}>
                    <span>หลักสูตรขั้นต้น</span>
                    {majorCourseBasic.map((course) => (
                      <Form.Check
                        value={course.pme_no}
                        label={course.name}
                        checked={isCourseUpdateAvailableChecked(course.pme_no)}
                        onChange={onCourseUpdateAvailableChange}
                      />
                    ))}
                  </Col>
                  <Col md={6}>
                    <span>หลักสูตรขั้นปลาย</span>
                    {majorCourseFinal.map((course) => (
                      <Form.Check
                        value={course.pme_no}
                        label={course.name}
                        checked={isCourseUpdateAvailableChecked(course.pme_no)}
                        onChange={onCourseUpdateAvailableChange}
                      />
                    ))}
                  </Col>
                </Row>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant='danger' onClick={handleDeleteUser}>
                ลบผู้ใช้งานระบบ
              </Button>
              <Button variant='secondary' onClick={handleClose}>
                ปิด
              </Button>
              <Button variant='primary' type='submit'>
                บันทึก
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal>
    </>
  )
}
